export default __webpack_public_path__ + "static/media/Group9188.aaddb181.svg";